import { TemplateConfig } from '../../template-config.interface';

export const disneySocialTop: TemplateConfig = {
  id: 'social-top',
  clientId: 'DISNEY',
  title: 'Top',
  description: '',
  aspectRatio: 'vertical',
  disabled: true,
  image: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/thumbnails/top.png',
  optimized_image: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/thumbnails/optimized/top.png',
  video: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/previews/top.mp4',
  formFields: [],
  promptTemplate: ''
};
